import React from 'react';
import { CHART_ARTIFACT_TYPE, isChartArtifactPayload } from '@cotera/api';
import type { ArtifactRendererProps } from './types';
import { registerArtifactRenderer } from './registry';
import { ChartArtifactView } from '@cotera/client/v0/components/charts';
import { Text } from '@cotera/client/app/components/ui';
import { ArtifactPanelExpandBar } from '../artifact-panel-expand-button';

const ChartArtifactRenderer: React.FC<ArtifactRendererProps> = ({
  artifact,
}) => {
  if (!isChartArtifactPayload(artifact.payload)) {
    return (
      <div className="flex h-full items-center justify-center p-4">
        <Text.P className="text-muted-foreground">Invalid chart data</Text.P>
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-0 flex-col">
      <ArtifactPanelExpandBar />
      <div className="min-h-0 flex-1 overflow-auto">
        <ChartArtifactView payload={artifact.payload} />
      </div>
    </div>
  );
};

registerArtifactRenderer(CHART_ARTIFACT_TYPE, ChartArtifactRenderer);
